
import { defineComponent, PropType } from 'vue';
import { B2BContentPageContent } from '@/types/B2BcontentServerContract';

export default defineComponent({
    name: 'FallbackPage',
    props: {
        content: {
            type: Object as PropType<B2BContentPageContent>,
            default: () => {},
        },
        alias: {
            type: String,
            default: '',
        },
    },
});
